import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import TopicFull from './topic-full';

const TopicFullWidget = (props) => {
  const queryClient = new QueryClient;
  return (
    <QueryClientProvider client={queryClient}>
      <TopicFull {...props}/>
    </QueryClientProvider>
  );
};

export { TopicFullWidget }
